import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { TabNav, TabNavItem } from 'shopper/components/TabNav';

import { sendEvent } from 'lib/gtag';
import { toLastCommentsLink } from 'lib/links';

import LAST_COMMENTS from 'constants/lastComments';

const LastCommentsTabNav = ({ commentsSource }) => {
  const [activeTab, setActiveTab] = useState(commentsSource);

  const onTabClick = (validCommentsSource) => {
    const { gaEventActionId } = validCommentsSource;

    sendEvent({
      category: 'tab_last_comments',
      action: `tab_${gaEventActionId}`,
    });
    setActiveTab(validCommentsSource);
  };

  return (
    <TabNav>
      {LAST_COMMENTS.VALID_COMMENT_SOURCES.map((validCommentsSource) => (
        <NextLink
          key={validCommentsSource.name}
          href={toLastCommentsLink(validCommentsSource.slug)}
          passHref
        >
          <TabNavItem
            active={activeTab.name === validCommentsSource.name}
            as="a"
            className="w-1/4 p-6"
            onClick={() => onTabClick(validCommentsSource)}
          >
            {validCommentsSource.displayName}
          </TabNavItem>
        </NextLink>
      ))}
    </TabNav>
  );
};

LastCommentsTabNav.propTypes = {
  commentsSource: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    gaEventActionId: PropTypes.string.isRequired,
    legacySlug: PropTypes.string,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string,
  }).isRequired,
};

export default LastCommentsTabNav;
